export const SEASONS_PAGE_HEADER = "Manage Seasons";
export const SEASONS_PAGE_SUBTITLE =
  "Add and edit seasons as well as categorize sports by season";

export const DEFAULT_SEASONS_SETTINGS = "Your seasons are set to default";
export const CUSTOMIZE_SEASONS_BUTTON_LABEL = "Customize seasons";

export const SAVE_SUCCESS = "Seasons saved successfully";
export const SAVE_FAILURE =
  "Something went wrong. Please try again by refreshing the page.";



// WEBPACK FOOTER //
// ./src/pages/director/seasons/seasonsPage/constants.ts